import BackButton from "@/components/buttons/back-button"
import { Outlet } from "react-router-dom"
import AdminTabs from "./_components/admin-tabs"
import Wrapper from "@/components/wrapper"
import Headline from "@/components/headline"
import useIsMobile from "@/hooks/use-is-mobile"
import Header from "@/routes/_layout/header"

const AdminLayout = () => {
  const isMobile = useIsMobile()
  const HeaderComponent = Header.default[isMobile ? "mobile" : "desktop"]

  return (
    <main className="min-h-screen bg-slate-50 text-slate-900 flex flex-col">
      <HeaderComponent />

      <Wrapper.maxWidth className="flex-1 flex flex-col py-2 relative pt-4">
        <Headline
          point={"ADMIN CONSOLE"}
          title={"관리자 페이지"}
          description={"단지 정보, 계정, 신규 등록, 활동 로그를 확인하고 관리합니다."}
        />

        <div className="bg-white rounded-2xl shadow-sm px-5 pb-5 flex flex-col flex-1 relative z-1">
          <AdminTabs />
          <Outlet />
          <div className="absolute w-110 right-0 bottom-0 -z-1 opacity-90">
            <img src="/images/admin-bg.png" />
          </div>
        </div>
      </Wrapper.maxWidth>
    </main>
  )
}

export default AdminLayout
